module.exports = __webpack_public_path__ + "img/IMG_8265.5ed62017.jpg";